import React from 'react'
import {Trans} from 'react-i18next'
import {SubtitleView} from './SubtitleStyles'

const SubtitleWithMigrationNote = ({styles}) => (
  <SubtitleView styles={styles}>
    <Trans i18nKey="migration.note" />
  </SubtitleView>
)

export default SubtitleWithMigrationNote
